/* Generated by scripts/generate-dcs-tools.ts
 * *DO NOT EDIT MANUALLY*
 */

import type { ResultError } from '@core/util/result';
import { err, ok, type Result } from 'neverthrow';
import * as schemas from './schemas';
import type * as types from './types';

type ToolParserMap = {
  BashCodeExecution: {
    call: types.BashCodeExecution;
    response: types.BashCodeExecutionResponse;
  };
  BulkSetEntityPropertyOptions: {
    call: types.BulkSetEntityPropertyOptions;
    response: types.BulkSetEntityPropertyOptionsResponse;
  };
  ContentSearch: {
    call: types.ContentSearch;
    response: types.SearchToolResponse;
  };
  CreateCalendarEvent: {
    call: types.CreateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  CreateDocument: {
    call: types.CreateDocument;
    response: types.CreateDocumentResponse;
  };
  CreateImportEntity: {
    call: types.CreateImportEntity;
    response: types.CreateImportEntityResponse;
  };
  CreateProject: {
    call: types.CreateProject;
    response: types.CreateProjectResponse;
  };
  CreateReminder: { call: types.CreateReminder; response: types.ToolReminder };
  CreateTag: { call: types.CreateTag; response: types.CreateTagResponse };
  DeleteCalendarEvent: {
    call: types.DeleteCalendarEvent;
    response: types.DeleteCalendarEventResponse;
  };
  DeleteImportEntity: {
    call: types.DeleteImportEntity;
    response: types.DeleteImportEntityResponse;
  };
  DeleteReminder: {
    call: types.DeleteReminder;
    response: types.DeleteReminderResponse;
  };
  DeleteTag: { call: types.DeleteTag; response: types.DeleteTagResponse };
  DisplayResults: {
    call: types.DisplayResults;
    response: types.DisplayResultsResponse;
  };
  EditDocument: {
    call: types.EditDocument;
    response: types.EditDocumentResponse;
  };
  EditTag: { call: types.EditTag; response: types.EditTagResponse };
  GetCompany: { call: types.GetCompany; response: types.GetCompanyResponse };
  GetEntityProperties: {
    call: types.GetEntityProperties;
    response: types.GetEntityPropertiesResponse;
  };
  GetThread: { call: types.GetThread; response: types.GetThreadResponse };
  ImportNotionPage: {
    call: types.ImportNotionPage;
    response: types.ImportNotionPageResponse;
  };
  ListCalendarEvents: {
    call: types.ListCalendarEvents;
    response: types.ListCalendarEventsResponse;
  };
  ListCalendars: {
    call: types.ListCalendars;
    response: types.ListCalendarsToolResponse;
  };
  ListCompanies: {
    call: types.ListCompanies;
    response: types.ListCompaniesResponse;
  };
  ListEntities: {
    call: types.ListEntities;
    response: types.ListEntitiesResponse;
  };
  ListImportEntities: {
    call: types.ListImportEntities;
    response: types.ListImportEntitiesResponse;
  };
  ListInboxes: { call: types.ListInboxes; response: types.ListInboxesResponse };
  ListLabels: { call: types.ListLabels; response: types.ListLabelsResponse };
  ListNotifications: {
    call: types.ListNotifications;
    response: types.ListNotificationsResponse;
  };
  ListReminders: {
    call: types.ListReminders;
    response: types.ListRemindersResponse;
  };
  ListSkills: { call: types.ListSkills; response: types.ListSkillsResponse };
  ListTags: { call: types.ListTags; response: types.ListTagsResponse };
  ListTeamMembers: {
    call: types.ListTeamMembers;
    response: types.ListTeamMembersResponse;
  };
  LoadTools: { call: types.LoadTools; response: types.LoadToolsResponse };
  MarkNotificationsDone: {
    call: types.MarkNotificationsDone;
    response: types.MarkNotificationsResponse;
  };
  MarkNotificationsSeen: {
    call: types.MarkNotificationsSeen;
    response: types.MarkNotificationsResponse;
  };
  MoveToProject: {
    call: types.MoveToProject;
    response: types.MoveToProjectResponse;
  };
  NameSearch: { call: types.NameSearch; response: types.SearchToolResponse };
  ReadCallRecord: {
    call: types.ReadCallRecord;
    response: types.ReadCallRecordResponse;
  };
  ReadChannelMessageContext: {
    call: types.ReadChannelMessageContext;
    response: types.ReadChannelMessageContextResponse;
  };
  ReadChannelMessages: {
    call: types.ReadChannelMessages;
    response: types.ReadChannelMessagesResponse;
  };
  ReadChannelThread: {
    call: types.ReadChannelThread;
    response: types.ReadChannelThreadResponse;
  };
  ReadChat: { call: types.ReadChat; response: types.ReadChatResponse };
  ReadContent: { call: types.ReadContent; response: types.ReadContentResponse };
  ReadMetadata: {
    call: types.ReadMetadata;
    response: types.ReadMetadataResponse;
  };
  ReadProject: { call: types.ReadProject; response: types.ReadProjectResponse };
  ReadThread: { call: types.ReadThread; response: types.ReadResponse };
  RenameDocument: {
    call: types.RenameDocument;
    response: types.RenameDocumentResponse;
  };
  SearchSkills: {
    call: types.SearchSkills;
    response: types.SearchSkillsResponse;
  };
  SearchTools: { call: types.SearchTools; response: types.SearchToolsResponse };
  SelfKnowledge: {
    call: types.SelfKnowledge;
    response: types.SelfKnowledgeResponse;
  };
  SendChannelMessage: {
    call: types.SendChannelMessage;
    response: types.SendChannelMessageResponse;
  };
  SendEmail: { call: types.SendEmail; response: types.UserToolResponse };
  SetEntityProperty: {
    call: types.SetEntityProperty;
    response: types.SetEntityPropertyResponse;
  };
  Subagent: { call: types.Subagent; response: types.SubagentResponse };
  TextEditorCodeExecution: {
    call: types.TextEditorCodeExecution;
    response: types.TextEditorCodeExecutionResponse;
  };
  UpdateCalendarEvent: {
    call: types.UpdateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  UpdateReminder: { call: types.UpdateReminder; response: types.ToolReminder };
  UpdateThreadLabels: {
    call: types.UpdateThreadLabels;
    response: types.UpdateThreadLabelsResponse;
  };
  WebFetch: { call: types.WebFetch; response: types.WebFetchResponse };
  WebSearch: { call: types.WebSearch; response: types.WebSearchResponse };
};

const toolParserMap = {
  BashCodeExecution: {
    call: schemas.BashCodeExecution,
    response: schemas.BashCodeExecutionResponse,
  },
  BulkSetEntityPropertyOptions: {
    call: schemas.BulkSetEntityPropertyOptions,
    response: schemas.BulkSetEntityPropertyOptionsResponse,
  },
  ContentSearch: {
    call: schemas.ContentSearch,
    response: schemas.SearchToolResponse,
  },
  CreateCalendarEvent: {
    call: schemas.CreateCalendarEvent,
    response: schemas.ToolCalendarEvent,
  },
  CreateDocument: {
    call: schemas.CreateDocument,
    response: schemas.CreateDocumentResponse,
  },
  CreateImportEntity: {
    call: schemas.CreateImportEntity,
    response: schemas.CreateImportEntityResponse,
  },
  CreateProject: {
    call: schemas.CreateProject,
    response: schemas.CreateProjectResponse,
  },
  CreateReminder: {
    call: schemas.CreateReminder,
    response: schemas.ToolReminder,
  },
  CreateTag: { call: schemas.CreateTag, response: schemas.CreateTagResponse },
  DeleteCalendarEvent: {
    call: schemas.DeleteCalendarEvent,
    response: schemas.DeleteCalendarEventResponse,
  },
  DeleteImportEntity: {
    call: schemas.DeleteImportEntity,
    response: schemas.DeleteImportEntityResponse,
  },
  DeleteReminder: {
    call: schemas.DeleteReminder,
    response: schemas.DeleteReminderResponse,
  },
  DeleteTag: { call: schemas.DeleteTag, response: schemas.DeleteTagResponse },
  DisplayResults: {
    call: schemas.DisplayResults,
    response: schemas.DisplayResultsResponse,
  },
  EditDocument: {
    call: schemas.EditDocument,
    response: schemas.EditDocumentResponse,
  },
  EditTag: { call: schemas.EditTag, response: schemas.EditTagResponse },
  GetCompany: {
    call: schemas.GetCompany,
    response: schemas.GetCompanyResponse,
  },
  GetEntityProperties: {
    call: schemas.GetEntityProperties,
    response: schemas.GetEntityPropertiesResponse,
  },
  GetThread: { call: schemas.GetThread, response: schemas.GetThreadResponse },
  ImportNotionPage: {
    call: schemas.ImportNotionPage,
    response: schemas.ImportNotionPageResponse,
  },
  ListCalendarEvents: {
    call: schemas.ListCalendarEvents,
    response: schemas.ListCalendarEventsResponse,
  },
  ListCalendars: {
    call: schemas.ListCalendars,
    response: schemas.ListCalendarsToolResponse,
  },
  ListCompanies: {
    call: schemas.ListCompanies,
    response: schemas.ListCompaniesResponse,
  },
  ListEntities: {
    call: schemas.ListEntities,
    response: schemas.ListEntitiesResponse,
  },
  ListImportEntities: {
    call: schemas.ListImportEntities,
    response: schemas.ListImportEntitiesResponse,
  },
  ListInboxes: {
    call: schemas.ListInboxes,
    response: schemas.ListInboxesResponse,
  },
  ListLabels: {
    call: schemas.ListLabels,
    response: schemas.ListLabelsResponse,
  },
  ListNotifications: {
    call: schemas.ListNotifications,
    response: schemas.ListNotificationsResponse,
  },
  ListReminders: {
    call: schemas.ListReminders,
    response: schemas.ListRemindersResponse,
  },
  ListSkills: {
    call: schemas.ListSkills,
    response: schemas.ListSkillsResponse,
  },
  ListTags: { call: schemas.ListTags, response: schemas.ListTagsResponse },
  ListTeamMembers: {
    call: schemas.ListTeamMembers,
    response: schemas.ListTeamMembersResponse,
  },
  LoadTools: { call: schemas.LoadTools, response: schemas.LoadToolsResponse },
  MarkNotificationsDone: {
    call: schemas.MarkNotificationsDone,
    response: schemas.MarkNotificationsResponse,
  },
  MarkNotificationsSeen: {
    call: schemas.MarkNotificationsSeen,
    response: schemas.MarkNotificationsResponse,
  },
  MoveToProject: {
    call: schemas.MoveToProject,
    response: schemas.MoveToProjectResponse,
  },
  NameSearch: {
    call: schemas.NameSearch,
    response: schemas.SearchToolResponse,
  },
  ReadCallRecord: {
    call: schemas.ReadCallRecord,
    response: schemas.ReadCallRecordResponse,
  },
  ReadChannelMessageContext: {
    call: schemas.ReadChannelMessageContext,
    response: schemas.ReadChannelMessageContextResponse,
  },
  ReadChannelMessages: {
    call: schemas.ReadChannelMessages,
    response: schemas.ReadChannelMessagesResponse,
  },
  ReadChannelThread: {
    call: schemas.ReadChannelThread,
    response: schemas.ReadChannelThreadResponse,
  },
  ReadChat: { call: schemas.ReadChat, response: schemas.ReadChatResponse },
  ReadContent: {
    call: schemas.ReadContent,
    response: schemas.ReadContentResponse,
  },
  ReadMetadata: {
    call: schemas.ReadMetadata,
    response: schemas.ReadMetadataResponse,
  },
  ReadProject: {
    call: schemas.ReadProject,
    response: schemas.ReadProjectResponse,
  },
  ReadThread: { call: schemas.ReadThread, response: schemas.ReadResponse },
  RenameDocument: {
    call: schemas.RenameDocument,
    response: schemas.RenameDocumentResponse,
  },
  SearchSkills: {
    call: schemas.SearchSkills,
    response: schemas.SearchSkillsResponse,
  },
  SearchTools: {
    call: schemas.SearchTools,
    response: schemas.SearchToolsResponse,
  },
  SelfKnowledge: {
    call: schemas.SelfKnowledge,
    response: schemas.SelfKnowledgeResponse,
  },
  SendChannelMessage: {
    call: schemas.SendChannelMessage,
    response: schemas.SendChannelMessageResponse,
  },
  SendEmail: { call: schemas.SendEmail, response: schemas.UserToolResponse },
  SetEntityProperty: {
    call: schemas.SetEntityProperty,
    response: schemas.SetEntityPropertyResponse,
  },
  Subagent: { call: schemas.Subagent, response: schemas.SubagentResponse },
  TextEditorCodeExecution: {
    call: schemas.TextEditorCodeExecution,
    response: schemas.TextEditorCodeExecutionResponse,
  },
  UpdateCalendarEvent: {
    call: schemas.UpdateCalendarEvent,
    response: schemas.ToolCalendarEvent,
  },
  UpdateReminder: {
    call: schemas.UpdateReminder,
    response: schemas.ToolReminder,
  },
  UpdateThreadLabels: {
    call: schemas.UpdateThreadLabels,
    response: schemas.UpdateThreadLabelsResponse,
  },
  WebFetch: { call: schemas.WebFetch, response: schemas.WebFetchResponse },
  WebSearch: { call: schemas.WebSearch, response: schemas.WebSearchResponse },
};

export type ToolName = keyof ToolParserMap;

type NamedRawTool = {
  id: string;
  name: string;
  json: unknown;
};

type ToolDataMap = {
  BashCodeExecution: {
    call: types.BashCodeExecution;
    response: types.BashCodeExecutionResponse;
  };
  BulkSetEntityPropertyOptions: {
    call: types.BulkSetEntityPropertyOptions;
    response: types.BulkSetEntityPropertyOptionsResponse;
  };
  ContentSearch: {
    call: types.ContentSearch;
    response: types.SearchToolResponse;
  };
  CreateCalendarEvent: {
    call: types.CreateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  CreateDocument: {
    call: types.CreateDocument;
    response: types.CreateDocumentResponse;
  };
  CreateImportEntity: {
    call: types.CreateImportEntity;
    response: types.CreateImportEntityResponse;
  };
  CreateProject: {
    call: types.CreateProject;
    response: types.CreateProjectResponse;
  };
  CreateReminder: { call: types.CreateReminder; response: types.ToolReminder };
  CreateTag: { call: types.CreateTag; response: types.CreateTagResponse };
  DeleteCalendarEvent: {
    call: types.DeleteCalendarEvent;
    response: types.DeleteCalendarEventResponse;
  };
  DeleteImportEntity: {
    call: types.DeleteImportEntity;
    response: types.DeleteImportEntityResponse;
  };
  DeleteReminder: {
    call: types.DeleteReminder;
    response: types.DeleteReminderResponse;
  };
  DeleteTag: { call: types.DeleteTag; response: types.DeleteTagResponse };
  DisplayResults: {
    call: types.DisplayResults;
    response: types.DisplayResultsResponse;
  };
  EditDocument: {
    call: types.EditDocument;
    response: types.EditDocumentResponse;
  };
  EditTag: { call: types.EditTag; response: types.EditTagResponse };
  GetCompany: { call: types.GetCompany; response: types.GetCompanyResponse };
  GetEntityProperties: {
    call: types.GetEntityProperties;
    response: types.GetEntityPropertiesResponse;
  };
  GetThread: { call: types.GetThread; response: types.GetThreadResponse };
  ImportNotionPage: {
    call: types.ImportNotionPage;
    response: types.ImportNotionPageResponse;
  };
  ListCalendarEvents: {
    call: types.ListCalendarEvents;
    response: types.ListCalendarEventsResponse;
  };
  ListCalendars: {
    call: types.ListCalendars;
    response: types.ListCalendarsToolResponse;
  };
  ListCompanies: {
    call: types.ListCompanies;
    response: types.ListCompaniesResponse;
  };
  ListEntities: {
    call: types.ListEntities;
    response: types.ListEntitiesResponse;
  };
  ListImportEntities: {
    call: types.ListImportEntities;
    response: types.ListImportEntitiesResponse;
  };
  ListInboxes: { call: types.ListInboxes; response: types.ListInboxesResponse };
  ListLabels: { call: types.ListLabels; response: types.ListLabelsResponse };
  ListNotifications: {
    call: types.ListNotifications;
    response: types.ListNotificationsResponse;
  };
  ListReminders: {
    call: types.ListReminders;
    response: types.ListRemindersResponse;
  };
  ListSkills: { call: types.ListSkills; response: types.ListSkillsResponse };
  ListTags: { call: types.ListTags; response: types.ListTagsResponse };
  ListTeamMembers: {
    call: types.ListTeamMembers;
    response: types.ListTeamMembersResponse;
  };
  LoadTools: { call: types.LoadTools; response: types.LoadToolsResponse };
  MarkNotificationsDone: {
    call: types.MarkNotificationsDone;
    response: types.MarkNotificationsResponse;
  };
  MarkNotificationsSeen: {
    call: types.MarkNotificationsSeen;
    response: types.MarkNotificationsResponse;
  };
  MoveToProject: {
    call: types.MoveToProject;
    response: types.MoveToProjectResponse;
  };
  NameSearch: { call: types.NameSearch; response: types.SearchToolResponse };
  ReadCallRecord: {
    call: types.ReadCallRecord;
    response: types.ReadCallRecordResponse;
  };
  ReadChannelMessageContext: {
    call: types.ReadChannelMessageContext;
    response: types.ReadChannelMessageContextResponse;
  };
  ReadChannelMessages: {
    call: types.ReadChannelMessages;
    response: types.ReadChannelMessagesResponse;
  };
  ReadChannelThread: {
    call: types.ReadChannelThread;
    response: types.ReadChannelThreadResponse;
  };
  ReadChat: { call: types.ReadChat; response: types.ReadChatResponse };
  ReadContent: { call: types.ReadContent; response: types.ReadContentResponse };
  ReadMetadata: {
    call: types.ReadMetadata;
    response: types.ReadMetadataResponse;
  };
  ReadProject: { call: types.ReadProject; response: types.ReadProjectResponse };
  ReadThread: { call: types.ReadThread; response: types.ReadResponse };
  RenameDocument: {
    call: types.RenameDocument;
    response: types.RenameDocumentResponse;
  };
  SearchSkills: {
    call: types.SearchSkills;
    response: types.SearchSkillsResponse;
  };
  SearchTools: { call: types.SearchTools; response: types.SearchToolsResponse };
  SelfKnowledge: {
    call: types.SelfKnowledge;
    response: types.SelfKnowledgeResponse;
  };
  SendChannelMessage: {
    call: types.SendChannelMessage;
    response: types.SendChannelMessageResponse;
  };
  SendEmail: { call: types.SendEmail; response: types.UserToolResponse };
  SetEntityProperty: {
    call: types.SetEntityProperty;
    response: types.SetEntityPropertyResponse;
  };
  Subagent: { call: types.Subagent; response: types.SubagentResponse };
  TextEditorCodeExecution: {
    call: types.TextEditorCodeExecution;
    response: types.TextEditorCodeExecutionResponse;
  };
  UpdateCalendarEvent: {
    call: types.UpdateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  UpdateReminder: { call: types.UpdateReminder; response: types.ToolReminder };
  UpdateThreadLabels: {
    call: types.UpdateThreadLabels;
    response: types.UpdateThreadLabelsResponse;
  };
  WebFetch: { call: types.WebFetch; response: types.WebFetchResponse };
  WebSearch: { call: types.WebSearch; response: types.WebSearchResponse };
};

export type NamedTool<
  TName extends ToolName = ToolName,
  TDirection extends 'call' | 'response' = 'call' | 'response',
> = {
  id: string;
  name: TName;
  data: ToolDataMap[TName][TDirection];
};

function deserializeTool<T extends NamedTool>(
  tool: NamedRawTool,
  direction: 'call' | 'response'
): Result<T, ResultError<'parse_error' | 'not_found'>[]> {
  if (!(tool.name in toolParserMap)) {
    return err([
      { code: 'not_found', message: `tool name not found ${tool.name}` },
    ]);
  }
  const parser = toolParserMap[tool.name as ToolName];
  const maybeToolCall = parser[direction].safeParse(tool.json);
  if (maybeToolCall.success) {
    return ok({
      id: tool.id,
      name: tool.name as ToolName,
      data: maybeToolCall.data,
    } as T);
  }
  return err([{ code: 'parse_error', message: 'tool parsing failed' }]);
}

export function deserializeToolCall(
  tool: NamedRawTool
): Result<
  NamedTool<ToolName, 'call'>,
  ResultError<'parse_error' | 'not_found'>[]
> {
  return deserializeTool(tool, 'call');
}

export function deserializeToolResponse(
  tool: NamedRawTool
): Result<
  NamedTool<ToolName, 'response'>,
  ResultError<'parse_error' | 'not_found'>[]
> {
  return deserializeTool(tool, 'response');
}
